import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getAvatarStyles, initialsStyles } from './Avatar.styles';

const Avatar = ({ initials, customStyles }) => (
  <Box sx={getAvatarStyles(customStyles)}>
    <Typography className="initials" sx={initialsStyles} variant="regular14">
      {initials}
    </Typography>
  </Box>
);

Avatar.propTypes = {
  initials: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
};

export default Avatar;
